import type { InventorySidebarMetadata } from '../schemas/sidebarMetadata';

/**
 * Clones sidebar menus and attaches `count` for Inventory parent/children from API metadata.
 */
export function applyInventorySidebarCounts(
  menus: readonly any[],
  inventory: InventorySidebarMetadata | null,
): any[] {
  if (!inventory) {
    return [...menus];
  }

  const scheduled = inventory.inventoryTransfer.scheduled;
  const suggested = inventory.inventoryTransfer.suggested;
  const transferTotal = scheduled + suggested;
  const replenishment = inventory.inventoryReplenishment;
  const parentTotal = transferTotal + replenishment;

  return menus.map(menu => {
    if (menu.key !== 'inventory-parent') {
      return menu;
    }

    return {
      ...menu,
      ...(parentTotal > 0 ? { count: parentTotal } : {}),
      menus: menu.menus.map((sub: any) => {
        if (sub.key === 'inventory-transfer') {
          return {
            ...sub,
            ...(transferTotal > 0 ? { count: transferTotal } : {}),
          };
        }
        if (sub.key === 'inventory-replenishment') {
          return {
            ...sub,
            ...(replenishment > 0 ? { count: replenishment } : {}),
          };
        }
        return sub;
      }),
    };
  });
}
